import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import {
  getApiBaseUrl,
  ADD_ACTIVITY,
  LOGIN,
  GET_LOCATIONS,
} from "../../../Config/Config";
import { Select } from "antd";

const FilterTreeEditAhuModel = ({
  onClose,
  blockName,
  blockId,
  areaName,
  areaId,
  ahuData,
  onSuccess,
}) => {
  const [ahuId, setAhuId] = useState("");
  const [blocks, setBlocks] = useState([]);

  const [areas, setAreas] = useState([]);

  const [selectedBlockId, setSelectedBlockId] = useState(null);
  const [selectedAreaId, setSelectedAreaId] = useState(null);

  const [loadingBlocks, setLoadingBlocks] = useState(false);
  const [loadingAreas, setLoadingAreas] = useState(false);

  const [ahuType, setAhuType] = useState("");
  const [lastCleaningDate, setLastCleaningDate] = useState("");
  const [freqAllowanceDays, setFreqAllowanceDays] = useState("");
  const [cleaningDays, setCleaningDays] = useState("");

  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const [loading, setLoading] = useState(false);
  console.log(loading, "loading");
  const [authLoading, setAuthLoading] = useState(false);
  const [askPassword, setAskPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  console.log(error, "error");

  const fetchBlocks = async () => {
    setLoadingBlocks(true);
    try {
      const res = await fetch(`${getApiBaseUrl()}${GET_LOCATIONS}`);
      const data = await res.json();
      setBlocks(data?.ResultData || []);
    } catch (err) {
      console.error("Block fetch error", err);
    } finally {
      setLoadingBlocks(false);
    }
  };

  const fetchAreas = async (blockId) => {
    if (!blockId) return;

    setLoadingAreas(true);
    try {
      const res = await fetch(
        `${getApiBaseUrl()}/Areas/getblockareas?BlockId=${blockId}`,
      );
      const data = await res.json();
      setAreas(data?.ResultData || []);
    } catch (err) {
      console.error("Area fetch error", err);
    } finally {
      setLoadingAreas(false);
    }
  };

  const handleSave = async () => {
    const logActivity = async (isSuccess, notes) => {
      try {
        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ActivityType: 1,
            PerformedBy: user?.UserID,
            PerformedOn: new Date()
              .toISOString()
              .slice(0, 19)
              .replace("T", " "),
            Notes: notes,
            Location: "addAHU",
            IsSucces: isSuccess ? 1 : 0,
          }),
        });
      } catch (err) {
        console.error("Failed to log activity:", err);
      }
    };

    const payload = {
      ID: ahuData.ID,
      Code: ahuId,
      UpdatedBy: user?.UserID,
      BlockId: selectedBlockId,
      AreaId: selectedAreaId,

      ProcessType: ahuType,
      ScheduleDate: lastCleaningDate,
      FreqAllowanceDays: Number(freqAllowanceDays),
      cleaningDays: Number(cleaningDays),
    };

    try {
      setLoading(true);

      const response = await fetch(`${getApiBaseUrl()}/ahuph2/updateahu`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok && result?.status !== false) {
        await logActivity(
          true,
          `AHU "${ahuId}" Updated successfully for Block "${blockName}", Area "${areaName}"`,
        );

        Swal.fire("Success", "AHU Edited successfully!", "success").then(() => {
          onSuccess(); // 🔥 reload ONLY areas
          onClose(); // close modal
        });
      } else {
        await logActivity(
          false,
          `Failed to add AHU "${ahuId}" for Block "${blockName}", Area "${areaName}"`,
        );

        Swal.fire("Failed", result?.message || "Unable to add AHU", "error");
      }
    } catch (error) {
      console.error("Network error:", error);

      await logActivity(
        false,
        `Error while adding AHU "${ahuId}": ${error.message}`,
      );

      Swal.fire("Error", "Unable to connect to server.", "error");
    } finally {
      setLoading(false);
      setAskPassword(false);
      setPassword("");
      setError("");
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      !ahuId ||
      !ahuType ||
      !lastCleaningDate ||
      !freqAllowanceDays ||
      !cleaningDays
    ) {
      Swal.fire(
        "Validation Error",
        "Please fill all required fields",
        "warning",
      );
      return;
    }

    setAskPassword(true);
  };
  const handleAuth = async () => {
    if (!password) {
      setError("Please enter your password.");
      return;
    }

    setAuthLoading(true);
    setError("");

    try {
      if (!user?.UserName) {
        throw new Error("User name not found in session data.");
      }

      const payload = {
        username: user.UserName,
        password,
      };

      const res = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.status) {
        setAskPassword(false);
        setPassword("");
        await handleSave();
      } else {
        throw new Error(
          data.Message || "Invalid credentials. Please try again.",
        );
      }
    } catch (err) {
      setError(err.message || "Unable to authenticate. Please try again.");
    } finally {
      setAuthLoading(false);
    }
  };

  useEffect(() => {
    if (ahuData) {
      console.log("Editing AHU:", ahuData);
    }
  }, [ahuData]);

  useEffect(() => {
    if (ahuData) {
      setAhuId(ahuData.Code || "");
      setAhuType(
        ahuData.ProcessType !== undefined && ahuData.ProcessType !== null
          ? ahuData.ProcessType.toString()
          : "",
      );
      setLastCleaningDate(
        ahuData.ScheduleDate
          ? ahuData.ScheduleDate.split("T")[0] // for date input
          : "",
      );

      setFreqAllowanceDays(ahuData.cleaningDays || "");
      setCleaningDays(ahuData.FreqAllowanceDays || "");
    }
  }, [ahuData]);

  useEffect(() => {
    if (!ahuData) {
      setAhuId("");
      setAhuType("");
      setLastCleaningDate("");
      setFreqAllowanceDays("");
      setCleaningDays("");
    }
  }, [ahuData]);

  useEffect(() => {
    fetchBlocks();
  }, []);

  useEffect(() => {
    if (blocks.length && blockId) {
      setSelectedBlockId(blockId);
    }
  }, [blocks, blockId]);

  useEffect(() => {
    if (!selectedBlockId) return;

    fetchAreas(selectedBlockId);
  }, [selectedBlockId]);

  useEffect(() => {
    if (areas.length && areaId) {
      setSelectedAreaId(areaId);
    }
  }, [areas, areaId]);

  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block", zIndex: 1055 }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit AHU</h5>
              <button
                type="button"
                onClick={onClose}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: "22px",
                  fontWeight: "bold",
                  lineHeight: "1",
                  cursor: "pointer",
                }}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Block</label>
                  <Select
                    style={{ width: "100%" }}
                    getPopupContainer={(triggerNode) =>
                      triggerNode.parentElement
                    }
                    placeholder="Select Block"
                    value={selectedBlockId}
                    loading={loadingBlocks}
                    onChange={(value) => {
                      setSelectedBlockId(value);
                      setSelectedAreaId(null); // ✅ reset ONLY on user action
                      setAreas([]);
                    }}
                    options={blocks.map((b) => ({
                      value: b.BlockId,
                      label: b.BlockName,
                    }))}
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Area</label>
                  <Select
                    style={{ width: "100%" }}
                    getPopupContainer={(triggerNode) =>
                      triggerNode.parentElement
                    }
                    placeholder="Select Area"
                    value={selectedAreaId}
                    loading={loadingAreas}
                    disabled={!selectedBlockId}
                    onChange={(value) => setSelectedAreaId(value)}
                    options={areas.map((a) => ({
                      value: a.Areaid,
                      label: a.AreaName,
                    }))}
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label">AHU ID</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="AHU001"
                    value={ahuId}
                    onChange={(e) => setAhuId(e.target.value)}
                  />
                </div>

                {/* AHU Type */}
                <div className="col-md-4 mb-3">
                  <label className="form-label">AHU Type</label>

                  <select
                    className="form-select"
                    value={ahuType}
                    onChange={(e) => setAhuType(e.target.value)}
                  >
                    <option value="">Select Type</option>
                    <option value="1">Processed</option>
                    <option value="2">Unprocessed</option>
                  </select>
                </div>

                {/* Last Cleaning Date */}
                <div className="col-md-4 mb-3">
                  <label className="form-label">Schedule Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={lastCleaningDate}
                    onChange={(e) => setLastCleaningDate(e.target.value)}
                  />
                </div>

                {/* Frequency Allowance Days */}
                <div className="col-4 mb-3">
                  <label className="form-label">Tolerance</label>
                  <span className="text-danger ms-1">*</span>
                  <div className="input-group">
                    <span className="input-group-text">±</span>
                    <input
                      type="number"
                      min={0}
                      className="form-control"
                      value={freqAllowanceDays}
                      onChange={(e) => setFreqAllowanceDays(e.target.value)}
                    />
                    <span className="input-group-text">Days</span>
                  </div>
                </div>
                <div className="col-4 mb-3">
                  <label className="form-label">Cleaning Frequency</label>
                  <span className="text-danger ms-1">*</span>
                  <div className="input-group">
                    <input
                      type="number"
                      min={0}
                      className="form-control"
                      value={cleaningDays}
                      onChange={(e) => setCleaningDays(e.target.value)}
                    />
                    <span className="input-group-text">Days</span>
                  </div>
                </div>
              </div>
              {askPassword && (
                <div className="mt-2">
                  <div className="mb-3 w-lg-75 m-auto">
                    <label className="form-label">
                      Confirm Password <span className="text-danger"> *</span>
                    </label>
                    <div className="pass-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        className="pass-input form-control"
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          setError("");
                        }}
                        onCopy={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                        onCut={(e) => e.preventDefault()}
                        placeholder="Enter Password"
                      />
                      <span
                        className={`ti toggle-password ${
                          showPassword ? "ti-eye" : "ti-eye-off"
                        }`}
                        onClick={() => setShowPassword(!showPassword)}
                      ></span>
                    </div>
                  </div>
                  <button
                    className="btn btn-primary btn-sm me-2"
                    onClick={handleAuth}
                    disabled={authLoading || !password}
                  >
                    {authLoading ? "Verifying..." : "Confirm"}
                  </button>
                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={() => {
                      setAskPassword(false);
                      setPassword("");
                      setError("");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>

            {askPassword && (
              <div className="modal-footer gap-2">
                <button className="btn btn-secondary" onClick={onClose}>
                  Close
                </button>
                <button className="btn btn-primary" onClick={handleSubmit}>
                  Save
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1050 }}
        onClick={onClose}
      />
    </>
  );
};

FilterTreeEditAhuModel.propTypes = {
  onClose: PropTypes.func.isRequired,
  blockName: PropTypes.string,
  blockId: PropTypes.number,
  areaName: PropTypes.string,
  areaId: PropTypes.number,
  onSuccess: PropTypes.string,

  ahuData: PropTypes.shape({
    ID: PropTypes.number,
    Code: PropTypes.string,
    ProcessType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    ScheduleDate: PropTypes.string,
    cleaningDays: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    FreqAllowanceDays: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }),
};

export default FilterTreeEditAhuModel;
